import {  useSearchParams } from 'react-router-dom'
import {PageLink} from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import SupplierDetails from './layouts/SupplierDetails'

const supplierUsersPageBreadcrumbs: PageLink[] = [
  {
    title: 'Supplier',
    path: '/supplier/dashboard',
    isActive: false,
  },
  {
    title: 'Users',
    path: '/supplier/users/users',
    isActive: false,
  },
]

const SupplierMappingDetailsPage = () => {
  useMeta('Supplier Users Details')
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');   
  const name = searchParams.get('name');   

  return (
    <Navigation
      baseUrl={`/supplier/users/mapping?id=${id}&name=${name}`}
      breadcrumbs={supplierUsersPageBreadcrumbs}
      navigationData={[
        {
          key: 'supplier-user-details',
          label: `Supplier user - ${name}`,
          component: <SupplierDetails />,
        },
      ]}
    />
  )
}
export default SupplierMappingDetailsPage
